import type { CategoryItem } from '~/types/searchTypes'

export default function (parentCategoryIds: number[], allCategories: CategoryItem[]): number[] {
  const result: number[] = []

  if (parentCategoryIds.length) {
    parentCategoryIds.forEach((categoryId) => {
      const category = allCategories.find((categoryItem) => categoryItem.id === categoryId)

      if (category) {
        result.push(category.id)
      }

      if (category && category.children_ids) {
        result.push(...category.children_ids)
      }
    })
  }

  return [...new Set(result)]
}
